module.exports = __webpack_public_path__ + "img/Union.c85da104.svg";